<template>
  <a-row class="container-fluid container-wrap col-sm-12 col-xs-12">
    <a-col :span="1"></a-col>
    <a-col class="justify-content-center" :span="22">
      <div style="margin-top: 28px"></div>
      <div class="card-header pb-0 col-sm-12 d-flex">
        <div class="col-sm-12 col-xs-12">
          <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
            <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
              구독 관리
            </h3>
            <span class="pageDesc">거래처 구독내역을 관리 할 수 있습니다.</span>
          </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2 table-with-search" style="margin-top: 20px">
        <div class="search-filter-container table-info-filter">
          <div class="search-filter-row">
            <div class="search-filter-title">
              검색어
            </div>
            <div class="search-filter-content">
              <div class="mobile-wrap">
                <a-select
                    size="small"
                    style="width: 150px"
                    v-model:value="searchFilter.keyword.option"
                    @change="v => searchFilter.keyword.option = v"
                >
                  <a-select-option value="거래처명">
                    거래처명
                  </a-select-option>
                  <a-select-option value="제품코드">
                    제품코드
                  </a-select-option>
                </a-select>
                <a-input
                    size="small"
                    v-model:value="searchFilter.keyword.word"
                    @keyup.enter="async (event) => {
                      paginationData.currentPage = 1
                      await uiHandler.search();
                    }"
                    @focusin="e => searchFilter.keyword.word = ''"
                    placeholder="검색어를 입력하세요"
                >
                  <template #prefix>
                    <i
                        class="fa-regular fa-magnifying-glass"
                    />
                  </template>
                </a-input>
              </div>
              <div class="mobile-wrap">
                <button
                    class="search-btn-filter"
                    @click="async (event) => {
                      paginationData.currentPage = 1
                      await uiHandler.search()
                    }"
                >
                  검색
                </button>
                <button
                    class="init-btn"
                    @click="event => {
                      searchFilter.keyword.option = '거래처명'
                      searchFilter.keyword.word = ''
                      searchFilter.deptName = ''
                      dateRanges = []
                      searchFilter.subscriptionStartDate = ''
                      searchFilter.subscriptionEndDate = ''
                      paginationData.currentPage = 1
                      searchFilter.selectedDateFilter = 'all'
                      uiHandler.search()
                    }"
                >
                  초기화
                </button>
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              계약일
            </div>
            <div class="search-filter-content">
              <div class="date-filter-container is-desktop-tablet">
                <div
                    class="date-filter-item"
                    :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                    @click="async (e) => {
                        searchFilter.selectedDateFilter = 'all'
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                >
                  전체
                </div>
                <div
                    v-for="item in searchFilter.dateFilters"
                    class="date-filter-item"
                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                    @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                >
                  {{
                    item === 'etc' ? '기간 설정' : `최근 ${uiHandler.convertMonthAndYearText(item)}`
                  }}
                </div>
              </div>

              <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                <a-range-picker
                    size="small"
                    :allowClear="false" :locale="locale" v-model:value="dateRanges"
                    @change="async (e) => {
                    searchFilter.selectedDateFilter = 'etc'
                    paginationData.currentPage = 1
                    await uiHandler.search()
                  }"
                    style="width: 250px;"/>
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              구독상태
            </div>
            <div class="search-filter-content">
              <a-select
                  style="width: 150px; min-width: 100px"
                  v-model:value="searchFilter.status"
                  @change="(val) => uiHandler.search({status: val})"
                  size="small"
                  :options="statusList"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-12 table-info-filter" style="display: flex; justify-content: space-between; margin-bottom: 20px; margin-top: 20px">
          <div class="total-div">
            <p>
              전체
              <span class="number-highlight">{{ formatCommaNumber(subscription.totalDocs) }}</span>
              건
            </p>
          </div>
          <div class="search-container">
            <a-select class="search-select" v-model:value="paginationData.rowsPerPage" style="width: 120px"
                      @change="uiHandler.search">
              <a-select-option :value="10" selected>10개씩 보기</a-select-option>
              <a-select-option :value="20">20개씩 보기</a-select-option>
              <a-select-option :value="50">50개씩 보기</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0">
          <div class="table-responsive table-wrap">
            <a-table class="ant-table-striped"
                     size="small"
                     bordered
                     :loading="dataLoading"
                     :scroll="{ x: '1900px' }"
                     :columns="subscription.columns"
                     :data-source="subscription.list"
                     :pagination="false"
            >
              <template #emptyText>
                <div class="noData">
                  <i class="fa-solid fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px"/><br>
                  <span>조회결과가 없습니다.</span>
                </div>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <pagination
          v-if="!noResult"
          :page-info="paginationData"
          page-name="SubscriptionList"
          @change-page="async (childPassParam) => {
            paginationData.currentPage = childPassParam.page;
            await uiHandler.search()
          }"
      />
    </a-col>
    <a-col :span="1"></a-col>
  </a-row>

  <!--  모달-->
  <subscrtiption-detail-modal
      :data-source="selectedPayments"
      :show-modal="modal.subscription.show"
      @close-modal="uiHandler.handleModal.subscriptionDetail.close"
  />
  <card-management-modal
      :data-source="selectedCards"
      :show-modal="modal.cardManagement.show"
      @close-modal="uiHandler.handleModal.cardManagement.close"
  />
</template>
<script>
import {defineComponent} from "vue";
import {
  InfoCircleOutlined,
} from '@ant-design/icons-vue';
import Pagination from "@/views/components/Pagination.vue";
import NoResult from "@/views/components/NoResult.vue";
import salesRecordApi from "@/views/Subscriptions/api";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";
import {dateUtils, formatCommaNumber, logging, oneBtnDialog} from "@/utils/utils";
import {styles} from "@/views/Subscriptions/styles";
import CardManagementModal from "@/views/Subscriptions/plasmapp/CardManagementModal.vue";
import SubscrtiptionDetailModal from "@/views/Subscriptions/plasmapp/SubscrtiptionDetailModal.vue";

export default defineComponent({
  components: {
    CardManagementModal,
    SubscrtiptionDetailModal,
    Pagination,
    NoResult,
    InfoCircleOutlined
  },
  async mounted() {
    await this.uiHandler.init();
  },
  computed: {
    noResult() {
      return !this.$store.state.isLoading && this.subscription.totalDocs === 0
    },
    statusList() {
      return [
        {label: '전체', value: '전체'},
        {label: '정상', value: '정상'},
        {label: '일시납', value: '일시납'},
        {label: '미납', value: '미납'},
      ]
    }
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      locale,
      dataLoading: false,
      formatCommaNumber,
      dateUtil: dateUtils(),
      companyInfo: JSON.parse(localStorage.getItem('CompanyInfo')),
      dateRanges: [dayjs().startOf('month'), dayjs()],
      modal: {
        subscription: {
          show: false
        },
        cardManagement: {
          show: false
        }
      },
      searchFilter: {
        keyword: {
          option: '거래처명',
          word: ''
        },
        status: '전체',
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 'etc'],
        startContractDate: '',
        endContractDate: '',
        sort: {
          parameter: 'validationDate',
          method: 'descend'
        }
      },
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 1,
      },
      selectedPayments: [],
      selectedCards: [],
      subscription: {
        totalDocs: 0,
        list: [],
        columns: [
          {
            key: 'status', title: '상태', dataIndex: 'status', align: 'center', fixed: 'left',
            customRender: ({text, record}) => {
              let statusColor;
              if (record.status === '정상') {
                statusColor = styles.tags.green
              } else if (record.status === '계약생성대기') {
                statusColor = styles.tags.blue
              } else {
                statusColor = styles.tags.red
              }
              return (
                  <div style="display: flex; justify-content: center">
                    {record.status ?
                        <a-tag style={{...styles.tags.statusTag, ...statusColor}}>
                          <span style={{fontSize: '14px'}}>{record.status}</span>
                        </a-tag> : <span>-</span>
                    }
                  </div>
              )
            }
          },
          {
            title: '결제정보',
            children: [
              {
                key: 'clientName',
                title: '거래처명',
                dataIndex: 'clientName',
                align: 'center',
                fixed: 'left',
                width: '240px'
              },
              {key: 'productName', title: '제품명', dataIndex: 'productName', align: 'center', width: '140px'},
              {
                key: 'productCode', title: '제품코드', dataIndex: 'productCode', align: 'center', width: '140px',
                customRender: ({text, record}) => {
                  return (
                      <a-row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <a-tooltip placement="top" title={text}>
                          <a-typography-text ellipsis>
                            {text}
                          </a-typography-text>
                        </a-tooltip>
                      </a-row>
                  )
                }
              },
              {
                key: 'periodicPaymentDate', title: '결제예정일', dataIndex: 'periodicPaymentDate', align: 'center',
                customRender: ({text, record}) => {
                  if (record.paymentInfos?.isOneTimePayment === 'Y') {
                    return ('일시납')
                  } else {
                    return (
                        `매월 ${record.periodicPaymentDate} 일`
                    )
                  }
                }
              },
              {
                key: 'cardCompany', title: '결제카드', dataIndex: 'cardCompany', align: 'center', width: '110px',
                customRender: ({text, record}) => {
                  if(!record || !record.cardInfos || !Array.isArray(record.cardInfos)) return '-';
                  const cardCompany = record.cardInfos[0]?.cardCompany
                  if (record.paymentInfos?.isOneTimePayment === 'Y') {
                    return "-"
                  } else {
                    return (
                        <a-col style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexDirection: 'column'
                        }}>
                          <a-row>
                            <span>{cardCompany}</span>
                          </a-row>
                          <a-row>
                            <a-button onClick={() => {
                                        this.modal.cardManagement.show = true
                                        this.selectedCards = record.cardInfos
                                      }}>카드관리
                            </a-button>
                          </a-row>
                        </a-col>
                    )
                  }
                }
              },
              {
                key: 'validationDate', dataIndex: 'validationDate', align: 'center',
                title: () => {
                  return (
                      <div style="display: flex; align-items: center; justify-content: center; gap: 4px">
                        유효기간
                        <a-tooltip title="카드 유효기간 3개월 미만 유효기간은 붉은색으로 나타납니다.">
                          <i class="fa-regular fa-info-circle" />
                        </a-tooltip>
                      </div>
                  )
                },
                customRender: ({text, record}) => {
                  let now = dayjs();
                  let validationDate = dayjs(record.validationDate, "YYYY-MM");

                  console.log('validationDate==>', `${validationDate}, ${now.diff(validationDate, 'month')}`);

                  if (now.diff(text, 'month') >= -2 && text !== '-') {
                    return <span style={{color: 'red'}}>{text}</span>
                  } else {
                    return <span>{text}</span>
                  }
                }
              },
              {
                key: 'totalPeriodCount', title: '약정기간', dataIndex: 'totalPeriodCount', align: 'center', width: '90px',
                customRender: ({text, record}) => {
                  console.log("===>", record.paymentInfos?.isOneTimePayment)
                  if (record.paymentInfos?.isOneTimePayment === 'Y') {
                    return ('일시납')
                  } else {
                    return (
                        `${record.currentPaymentPeriodCount}/${text} 개월`
                    )
                  }
                }
              },
              {
                key: 'subscriptionAmount',
                title: '정기결제금액',
                dataIndex: 'subscriptionAmount',
                align: 'center',
                width: '120px',
                customRender: ({text, record}) => {
                  const subscriptionAmount = record?.subscriptionAmount?.toLocaleString();
                  if (record.paymentInfos?.isOneTimePayment === 'Y') {
                    return (
                        <div style={{display: 'flex', justifyContent: 'end'}}>
                          <a-typography-text>{subscriptionAmount}원</a-typography-text>
                        </div>
                    )
                  } else {
                    return (
                        <div style={{display: 'flex', justifyContent: 'end'}}>
                          <a-typography-text>월 {subscriptionAmount}원</a-typography-text>
                        </div>
                    )
                  }
                }
              },
            ]
          },
          {
            title: '계약정보',
            children: [
              {
                key: 'contractDate', title: '계약대수', dataIndex: 'contractDate', align: 'center', width: '80px',
                customRender: ({text, record}) => {
                  const count = record.productCode?.split(",").length
                  return (
                      `${count}대`
                  )
                }
              },
              {
                key: 'contractDate', title: '계약일', dataIndex: 'contractDate', align: 'center', width: '100px',
                customRender: ({text, record}) => {
                  return record.contractInfo ? text : <div>
                    <button style={{marginLeft: "10px", padding: "6px", "border-radius": '5px'}}
                            onClick={() => this.$router.push("/contract/actilink-rental/2c618b40-f56b-11ee-9b10-33ac85a1d5c7?name=ACTILINK+정기+렌탈서비스+약정서&group=영업")}>계약서
                      생성
                    </button>
                  </div>;
                },
              },
              {key: 'companyManager', title: '계약담당자', dataIndex: 'companyManager', align: 'center', width: '110px'},
              {
                key: 'subscriptionPaymentDate', title: '결제내역', dataIndex: 'subscriptionPaymentDate', align: 'center',
                customRender: ({text, record}) => {
                  if (record.paymentInfos?.isOneTimePayment === 'Y') {
                    return "-"
                  } else {
                    return (
                        record.contractInfo ?
                            <a-col style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              flexDirection: 'column'
                            }}>
                              <a-row>
                                <span>{text}</span>
                              </a-row>
                              <a-row>
                                <a-button onClick={() => {
                                            this.modal.subscription.show = true
                                            this.selectedPayments = record.payments
                                          }}>보기
                                </a-button>
                              </a-row>
                            </a-col> : '-'
                    )
                  }
                }
              },
            ]
          },
        ]
      },
    }
  },
  methods: {
    ui() {
      return {
        convertMonthAndYearText: (input) => {
          if (input < 12) return `${input}개월`;
          return `${input / 12}년`;
        },
        init: async () => {
          await this.uiHandler.search()
        },
        search: async () => {
          this.dataLoading = true
          const params = {
            page: this.paginationData.currentPage,
            limit: this.paginationData.rowsPerPage
          }

          if (this.searchFilter.keyword.word) {
            if (this.searchFilter.keyword.option === '거래처명') {
              params['clientName'] = this.searchFilter.keyword.word
            }

            if (this.searchFilter.keyword.option === '제품코드') {
              params['productCode'] = this.searchFilter.keyword.word
            }
          }

          if (this.searchFilter.selectedDateFilter === 'all') {
            params["startContractDate"] = '20230101'
            params["endContractDate"] = '99991231'
          }
          if (this.searchFilter.selectedDateFilter === 3) {
            params["startContractDate"] = dayjs().subtract(3, 'month').format('YYYYMMDD')
            params["endContractDate"] = dayjs().format('YYYYMMDD')
          }
          if (this.searchFilter.selectedDateFilter === 12) {
            params["startContractDate"] = dayjs().subtract(12, 'month').format('YYYYMMDD')
            params["endContractDate"] = dayjs().format('YYYYMMDD')
          }
          if (this.searchFilter.selectedDateFilter === 'etc') {
            params["startContractDate"] = dayjs(this.dateRanges[0]?.valueOf()).format('YYYYMMDD')
            params["endContractDate"] = dayjs(this.dateRanges[1]?.valueOf()).format('YYYYMMDD')
          }
          if (this.searchFilter.startContractDate && this.searchFilter.endContractDate) {
            params["startContractDate"] = this.searchFilter.salesStartDate
            params["endContractDate"] = this.searchFilter.salesEndDate
          }

          if (this.searchFilter.status) {
            if (this.searchFilter.status !== "전체") {
              params["status"] = this.searchFilter.status
            }
          }

          if(this.searchFilter.sort.parameter && this.searchFilter.sort.method) {
            params['sort'] = this.searchFilter.sort;
          }

          await this.apiHandler.getSubscriptions(params, (response) => {
            this.subscription.totalDocs = response.data.totalDocs;
            this.paginationData.totalPages = response.data.totalPages;
            this.subscription.list = response.data.docs
            for (let i = 0; i < this.subscription.list.length; i++) {
              const item = this.subscription.list[i];
              item.index = this.subscription.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
            }

          }, (error) => {

          }).finally(() => this.dataLoading = false)
        },
        getManagerInfo: (item) => {
          logging().exceptProd('managerinfo => ', item)
          const mobile = item.mobile;
          if (!item.email) return mobile;
          return `${mobile} / ${item.email}`;
        },
        fileDownload: async (contractId) => {
          await this.apiHandler.getContract(
              contractId,
              true,
              async (response) => {
                if (response.data?.file?.downloadUrl) {
                  window.open(response?.data?.file?.downloadUrl);
                }
              },
              (error) => {
                logging().exceptProd('getContracts fail==>', error);
                oneBtnDialog('다운로드 오류', '파일 다운로드에 실패했습니다.', false);
              }
          );
        },
        handleModal: {
          subscriptionDetail: {
            show: async () => {
              this.$store.commit('setIsLoading', true);
              this.modal.subscription.show = true
              this.$store.commit('setIsLoading', false);
            },
            close: async () => {
              await this.uiHandler.search();
              this.modal.subscription.show = false
            }
          },
          cardManagement: {
            show: async () => {
              this.$store.commit('setIsLoading', true);
              this.modal.cardManagement.show = true
              this.$store.commit('setIsLoading', false);
            },
            close: async () => {
              await this.uiHandler.search();
              this.modal.cardManagement.show = false
            }
          }
        }
      }
    },
    api() {
      return salesRecordApi(this.$apiInstance, this.$store)
    }
  }
})
</script>
<style scoped lang="scss">
.search-filter-content {
  .mobile-wrap {
    display: flex;
    gap: 8px;
  }

  .mobile-no-wrap {
    display: flex;
  }
}

@media screen and (max-width: 767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range {
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .date-filter-container {
      flex-direction: row;
      border-radius: 0;
      border-bottom: 0;

      .date-filter-item {
        width: 50%;
        border-bottom: 0;
      }
    }
  }
  .container-fluid .row.justify-content-center {
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv {
    width: 100% !important;
  }
  .search-filter-title {
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap {
    width: 100%;
  }
  .search-filter-content .search-select {
    width: 100px;
  }
  .search-filter-content .search-input-container {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;

    input {
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container {
    height: auto;
  }
  .search-filter-content .date-selector-container.custom {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container {
    flex-direction: column;
  }
  .search-filter-row {
    height: auto;
  }
  .search-filter-row,
  .search-filter-content {
    flex-direction: column;
    flex: none;
  }
  .card-header {
    margin: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .search-filter-title {
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  .table-with-search .table-info-filter {
    flex-direction: column;
    width: 100%;

    .total-div {
      margin-right: auto;
    }

    .search-container {
      width: 100%;
      flex-direction: row;

      .search-select {
        margin-right: auto;
      }

      .search-div {
        flex-direction: row;
        width: 100%;

        input {
          width: calc(100% - 80px) !important;
        }

        .search-btn {
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row {
    flex-direction: column;
    height: auto;

    &:nth-of-type(2) {
      .search-filter-content {
        flex-direction: column;
      }

      .search-filter-content {
        align-items: flex-start;
      }

      .date-selector-container.custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }

      .n-date-picker {
        width: 150px;
      }
    }
  }
}
</style>